import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, resolving Tailwind conflicts in favour of the last one.
 *
 * `clsx` handles conditionals; `twMerge` makes `cn('p-2', 'p-4')` produce
 * `'p-4'` instead of both. This is what lets a component accept a `className`
 * prop that can actually override its own defaults.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
